export default __webpack_public_path__ + "static/media/1_Login.973e0e83.png";